var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 77,
    viewBox: "0 0 58 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5666 5.45884L15.353 13.2866L22.2334 8.6653C24.9747 11.0612 27.5899 14.4686 29.4968 19.0433L25.3718 25.9481L31.0712 23.5765C32.0924 27.1277 32.8078 31.3257 32.9958 36.1427C32.9958 36.1427 24.6425 32.7053 16.6533 26.3457L20.0455 18.0941L12.8874 23.1374C7.03142 17.7283 2.1615 10.7302 2.06096 2.49998C2.06096 2.49998 9.74078 1.4023 17.5666 5.45884Z",
    fill: "#FFBA94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6887 58.5982L28.2718 67.7389L21.5115 65.0706L19.4303 44.7237L10.1521 60.4597L6.28703 58.951L5.15017 48.1949L0.177877 56.4779L-18.6899 48.8772C-18.6899 48.8772 -5.99717 29.2295 18.0123 37.1283C42.0358 44.9147 48.8314 63.5662 48.8434 76.1225L34.9073 70.5058L33.6887 58.5982Z",
    fill: "#FFBA94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsLeft);
export default __webpack_public_path__ + "static/media/palmLeafsLeft.f2a1b57090de7e19d8589db4b8fdf3a2.svg";
export { ForwardRef as ReactComponent };